var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
import * as moment from 'moment';
var HelperService = /** @class */ (function () {
    function HelperService() {
    }
    HelperService.copyObj = function (obj) {
        if (obj === void 0) { obj = {}; }
        return _.cloneDeep(obj);
    };
    HelperService.getQueryString = function (find, select) {
        var _this = this;
        if (find === void 0) { find = {}; }
        if (select === void 0) { select = []; }
        var keywords = Object.keys(find);
        var specialOperator = [
            'sort',
            'limit',
            'offset',
        ];
        var queryString = keywords.reduce(function (acc, keyword, index) {
            if (keyword === 'status' && find[keyword] === 'all') {
                acc = acc;
                return acc;
            }
            var findCondition = find[keyword];
            if (specialOperator.includes(keyword)) {
                acc += keyword + "=" + findCondition;
            }
            else if (findCondition instanceof Array) {
                acc += keyword + "__in=" + findCondition.join(',');
            }
            else if (typeof findCondition === 'object') {
                acc += _this.makeConditionQuery(keyword, findCondition);
            }
            else {
                acc += keyword + "__eq=" + findCondition;
            }
            acc += "&";
            return acc;
        }, '');
        if (select && select.length) {
            queryString += "select=" + select.join(',');
        }
        return queryString;
    };
    HelperService.queryString = function (query) {
        if (query === void 0) { query = {}; }
        var keywords = Object.keys(query);
        var queryString = keywords.reduce(function (acc, keyword) {
            var findCondition = query[keyword];
            // if (specialOperator.includes(keyword)) {
            //   acc += `${keyword}=${findCondition}`;
            // } else if (findCondition instanceof Array) {
            //   acc += `${keyword}__in=${findCondition.join(',')}`;
            // } else if (typeof findCondition === 'object' ) {
            //   acc += this.makeConditionQuery(keyword, findCondition);
            // } else {
            acc += keyword + "=" + findCondition;
            // }
            acc += "&";
            return acc;
        }, '');
        return queryString;
    };
    HelperService.makeConditionQuery = function (parent, condition) {
        var conditionOperators = Object.keys(condition);
        var conditionQueryString = conditionOperators.map(function (cond) {
            return parent + "__" + cond + "=" + condition[cond];
        });
        return conditionQueryString.join('&');
    };
    HelperService.timestampToReadableFormat = function (timeStamp) {
        var date = new Date(timeStamp);
        var timeString = date.toLocaleTimeString().split(':').splice(0, 2).join(':');
        return timeString + " " + HelperService.dateString(date);
    };
    HelperService.formatDateWithTime = function (dateValue) {
        return moment(dateValue).format('DD/MM/YYYY HH:mm');
    };
    HelperService.isValidDate = function (date) {
        return (date && date.getTime()) ? true : false;
    };
    HelperService.getDateOnly = function (date) {
        var monthDate = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        return year + "-" + month + "-" + monthDate.toString().padStart(2, '0');
    };
    HelperService.getDateOnlyV1 = function (date) {
        var monthDate = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        return year + "-" + month.toString().padStart(2, '0') + "-" + monthDate.toString().padStart(2, '0');
    };
    HelperService.setCookie = function (data) {
        if (data === void 0) { data = {}; }
        Object.keys(data).map(function (key) {
            var value = data[key];
            if (typeof value === 'object') {
                value = JSON.stringify(value);
            }
            document.cookie = key + "=" + value + ";path=/";
        });
    };
    HelperService.regexString = function (string) {
        return string + "$/i";
    };
    HelperService.roundNumber = function (num) {
        // const roundTwoDecimal = (num) => {
        return Math.round(num * 100) / 100;
        //  };
    };
    HelperService.getOrderDateyUniqueId = function (uniqueId) {
        return __awaiter(this, void 0, void 0, function () {
            var ts, date;
            return __generator(this, function (_a) {
                if (uniqueId.length !== 19) {
                    return [2 /*return*/, null];
                }
                ts = uniqueId.replace("RD", "");
                if (!Date.parse(ts)) {
                    ts = parseInt(ts.toString().split('').reverse().splice(4).reverse().join(''));
                    if (!Date.parse(new Date(ts).toString())) {
                        return [2 /*return*/, null];
                    }
                }
                date = HelperService.getDateOnlyV1(new Date(ts));
                return [2 /*return*/, date];
            });
        });
    };
    HelperService.accessCookie = function (cookieName) {
        var name = cookieName + '=';
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name) === 0) {
                return temp.substring(name.length, temp.length);
            }
        }
        return '';
    };
    HelperService.dateString = function (date) {
        if (date && Date.parse(date)) {
            return new Date(date).toDateString();
        }
        return 'N/A';
    };
    HelperService.getCurrentUrl = function () {
        return window.location.href;
    };
    HelperService.getCurrentPath = function () {
        return window.location.pathname;
    };
    HelperService.removeParam = function (params) {
        if (params === void 0) { params = []; }
        var baseUrl = window.location.origin;
        var pathname = window.location.pathname;
        var routeParams = this.routeParams();
        var filteredParams = Object.keys(routeParams).reduce(function (acc, param) {
            if (!params.includes(param)) {
                acc[param] = routeParams[param];
            }
            return acc;
        }, {});
        var queryString = HelperService.queryString(filteredParams);
        return queryString ?
            "" + baseUrl + pathname + "?" + HelperService.queryString(filteredParams) : "" + baseUrl + pathname;
    };
    HelperService.routeParams = function () {
        return decodeURIComponent(window.location.search.substring(1)).split('&')
            .reduce(function (acc, keyValue) {
            var data = keyValue.split('=');
            acc[data[0]] = data[1];
            return acc;
        }, {});
    };
    HelperService.getBaseRouteFromUrl = function (url) {
        return url.split('/').splice(0, 3).join('/');
    };
    HelperService.minutesToReadableHourMinuteFormat = function (minutes) {
        var date = new Date('1-1-2019');
        date.setMinutes(minutes);
        var readableString = '';
        if (date.getHours()) {
            readableString = date.getHours() + " hours";
        }
        if (date.getMinutes()) {
            readableString += " " + date.getMinutes() + " min";
        }
        return readableString.trim();
    };
    HelperService.timeStampToDateOnly = function (date) {
        var d = new Date(date), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }
        return [year, month, day].join('-');
    };
    HelperService.encode = function (data) {
        return btoa(btoa(data));
    };
    HelperService.endcodeToLevel = function (data, encodeLevel) {
        encodeLevel = parseInt(encodeLevel, 10) || 0;
        for (var i = 0; i < encodeLevel; i++) {
            data = HelperService.encode(data);
        }
        return data;
    };
    HelperService.decode = function (data) {
        try {
            return atob(atob(data));
        }
        catch (err) {
            console.log(err);
            return data;
        }
    };
    HelperService.resetTimeTo = function (date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        return date;
    };
    HelperService.redirect = function (url, withReferer) {
        if (withReferer === void 0) { withReferer = true; }
        var referrer = document.URL;
        var finalUrl = withReferer ? url + "?referrer=" + referrer : url;
        window.location.replace(finalUrl);
    };
    HelperService.redirectToOldDashboard = function (relativeRoute, queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        var basePath = environment.rapido_dashboard;
        // const token = HelperService.accessCookie('token');
        var queryString = HelperService.queryString(Object.assign({}, queryParams));
        var path = basePath + "/" + relativeRoute + "?" + queryString;
        // const path = `${basePath}/${relativeRoute}?token=${token}`;
        // window.location.replace(path);
        window.open(path, '_blank');
    };
    HelperService.redirectToNewPage = function (url) {
        window.open(url, '_blank');
    };
    // static redirect(url) {
    //   window.location.replace(url);
    // }
    HelperService.openInMap = function (lat, lng) {
        if (lat && lng) {
            var googleUrl = "https://maps.google.com/?q=" + lat + "," + lng;
            this.redirectToNewPage(googleUrl);
        }
    };
    HelperService.convert24to12hrFormat = function (time) {
        var timeIn12HrFormat = time;
        var meridian = 'am';
        if (time) {
            var parts = time.split(':');
            if (parts.length === 2) {
                if (parseInt(parts[0], 10)) {
                    if (parseInt(parts[0], 10) > 12) {
                        parts[0] = parseInt(parts[0], 10) - 12;
                        meridian = 'pm';
                    }
                    else if (parseInt(parts[0], 10) === 12) {
                        meridian = 'pm';
                    }
                }
            }
            timeIn12HrFormat = parts.join(':') + ' ' + meridian;
        }
        return timeIn12HrFormat;
    };
    // Numeric timestamp (ms) from tripDate + startTime; falls back to creation date, then 0.
    HelperService.getTripSortTimestamp = function (order, tripStartTimeMap, tripIdKey) {
        var tripId = order.poolData && order.poolData[tripIdKey];
        var tripDate = order.poolData && order.poolData.tripDate;
        var startTime = HelperService.getTripStartTime(tripStartTimeMap, tripId, tripDate);
        var normalizedStartTime = (startTime && startTime !== '-') ? startTime : '00:00';
        if (tripDate) {
            var withTime = moment(tripDate + " " + normalizedStartTime, ['YYYY-MM-DD H:mm', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD HH:mm:ss'], true);
            if (withTime.isValid()) {
                return withTime.valueOf();
            }
            var dateOnly = moment(tripDate, 'YYYY-MM-DD', true);
            if (dateOnly.isValid()) {
                return dateOnly.valueOf();
            }
        }
        return order.date ? new Date(order.date).getTime() : 0;
    };
    HelperService.tripStartTimeCacheKey = function (tripId, tripDate) {
        return tripId + ":" + tripDate;
    };
    HelperService.collectUniqueTripIds = function (orders, tripIdKey) {
        var ids = new Set();
        for (var _i = 0, orders_1 = orders; _i < orders_1.length; _i++) {
            var order = orders_1[_i];
            var tripId = order && order.poolData && order.poolData[tripIdKey];
            if (tripId) {
                ids.add(tripId);
            }
        }
        return Array.from(ids);
    };
    HelperService.getFirstOrderTripDate = function (orders) {
        for (var _i = 0, orders_2 = orders; _i < orders_2.length; _i++) {
            var order = orders_2[_i];
            var tripDate = order && order.poolData && order.poolData.tripDate;
            if (tripDate) {
                return tripDate;
            }
        }
        return undefined;
    };
    HelperService.indexTripsById = function (trips) {
        var map = new Map();
        (trips || []).forEach(function (trip) {
            var tripId = trip && (trip.id || trip._id);
            if (tripId) {
                map.set(tripId, trip);
            }
        });
        return map;
    };
    HelperService.normalizeDayOfWeekFromDate = function (tripDate) {
        var parsed = moment(tripDate, 'YYYY-MM-DD', true);
        return parsed.isValid() ? parsed.format('dddd').toLowerCase() : '';
    };
    HelperService.parseDaySchedules = function (trip) {
        var daySchedules = trip && trip.daySchedules;
        if (!daySchedules) {
            return [];
        }
        if (Array.isArray(daySchedules)) {
            return daySchedules.filter(Boolean);
        }
        if (typeof daySchedules === 'object') {
            return Object.keys(daySchedules).map(function (day) { return (__assign({ dayOfWeek: day }, daySchedules[day])); });
        }
        return [];
    };
    HelperService.scheduleForDay = function (trip, tripDate) {
        var day = HelperService.normalizeDayOfWeekFromDate(tripDate);
        if (!day) {
            return null;
        }
        var schedules = HelperService.parseDaySchedules(trip);
        return schedules.find(function (schedule) {
            return schedule && String(schedule.dayOfWeek || '').toLowerCase() === day;
        }) || null;
    };
    HelperService.hydrateTripStartTime = function (trip, tripDate) {
        if (!trip) {
            return '-';
        }
        var schedule = HelperService.scheduleForDay(trip, tripDate);
        if (schedule && schedule.startTime) {
            return schedule.startTime;
        }
        if (trip.date === tripDate && trip.startTime) {
            return trip.startTime;
        }
        return trip.startTime || '-';
    };
    HelperService.tripFromBulkResponse = function (response, tripId, tripDate) {
        if (!response || !tripId) {
            return null;
        }
        var trips = (response.trip || (response.data && response.data.trip) || []);
        var matched = trips.find(function (trip) {
            var id = trip && (trip.id || trip._id);
            return id === tripId;
        });
        return HelperService.normalizePoolTripForDisplay(matched, tripDate);
    };
    HelperService.normalizePoolTripForDisplay = function (trip, tripDate) {
        if (!trip) {
            return trip;
        }
        var normalized = __assign({}, trip);
        if (!normalized.routeDetails && Array.isArray(normalized.routes) && normalized.routes[0]) {
            normalized.routeDetails = normalized.routes[0];
        }
        if (tripDate) {
            var startTime = HelperService.hydrateTripStartTime(trip, tripDate);
            if (startTime && startTime !== '-') {
                normalized.startTime = startTime;
            }
            var schedule = HelperService.scheduleForDay(trip, tripDate);
            if (schedule && schedule.startTimeForDayInSeconds) {
                normalized.startTimeForDayInSeconds = schedule.startTimeForDayInSeconds;
            }
        }
        return normalized;
    };
    HelperService.hydrateTrips = function (trips, orders, tripIdKey) {
        var tripsById = HelperService.indexTripsById(trips);
        var tripStartTimeMap = {};
        for (var _i = 0, orders_3 = orders; _i < orders_3.length; _i++) {
            var order = orders_3[_i];
            var poolData = order && order.poolData;
            if (!poolData) {
                continue;
            }
            var tripId = poolData[tripIdKey];
            var tripDate = poolData.tripDate;
            if (!tripId || !tripDate) {
                continue;
            }
            var cacheKey = HelperService.tripStartTimeCacheKey(tripId, tripDate);
            if (tripStartTimeMap[cacheKey]) {
                continue;
            }
            var startTime = HelperService.hydrateTripStartTime(tripsById.get(tripId), tripDate);
            tripStartTimeMap[cacheKey] = startTime;
            if (!tripStartTimeMap[tripId]) {
                tripStartTimeMap[tripId] = startTime;
            }
        }
        return tripStartTimeMap;
    };
    HelperService.getTripStartTime = function (tripStartTimeMap, tripId, tripDate) {
        if (!tripId) {
            return '-';
        }
        if (tripDate) {
            var keyed = tripStartTimeMap[HelperService.tripStartTimeCacheKey(tripId, tripDate)];
            if (keyed) {
                return keyed;
            }
        }
        return tripStartTimeMap[tripId] || '-';
    };
    HelperService.fetchTripStartTimeMap = function (orders, tripIdKey, getTripsBulk) {
        return __awaiter(this, void 0, void 0, function () {
            var tripIds, bulkDate, response, trips, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tripIds = HelperService.collectUniqueTripIds(orders, tripIdKey);
                        if (tripIds.length === 0) {
                            return [2 /*return*/, {}];
                        }
                        bulkDate = HelperService.getFirstOrderTripDate(orders);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getTripsBulk(tripIds, bulkDate)];
                    case 2:
                        response = _a.sent();
                        trips = (response && response.trip) || [];
                        return [2 /*return*/, HelperService.hydrateTrips(trips, orders, tripIdKey)];
                    case 3:
                        e_1 = _a.sent();
                        console.error('Error fetching trips bulk:', e_1);
                        return [2 /*return*/, {}];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Sorts corporate pool orders by tripDate + startTime (desc). Client-side, current page only.
    HelperService.sortByTripDateAndStartTime = function (orders, tripStartTimeMap, tripIdKey) {
        return orders.slice().sort(function (a, b) {
            var aTs = HelperService.getTripSortTimestamp(a, tripStartTimeMap, tripIdKey);
            var bTs = HelperService.getTripSortTimestamp(b, tripStartTimeMap, tripIdKey);
            return bTs - aTs;
        });
    };
    // Formats trip date "YYYY-MM-DD" → "ddd, DD MMM YYYY" and 24h start time "HH:mm" → "hh:mm A".
    HelperService.formatTripDateTimeDisplay = function (tripDate, startTime) {
        var tripDateDisplay = '-';
        if (tripDate) {
            var parsed = moment(tripDate, 'YYYY-MM-DD', true);
            tripDateDisplay = parsed.isValid() ? parsed.format('ddd, DD MMM YYYY') : tripDate;
        }
        var startTimeDisplay = '-';
        if (startTime && startTime !== '-') {
            var parsedTime = moment(startTime, ['HH:mm', 'H:mm', 'HH:mm:ss'], true);
            startTimeDisplay = parsedTime.isValid() ? parsedTime.format('hh:mm A') : startTime;
        }
        return { tripDateDisplay: tripDateDisplay, startTimeDisplay: startTimeDisplay };
    };
    HelperService.formatPoolDataDisplay = function (poolData) {
        var tripDateDisplay = '-';
        if (poolData && poolData.tripDate) {
            tripDateDisplay = poolData.tripDate;
        }
        var initiatedByDisplay = '-';
        if (poolData && poolData.initiatedBy) {
            var initiatedBy = poolData.initiatedBy;
            initiatedByDisplay = initiatedBy.charAt(0).toUpperCase() + initiatedBy.slice(1);
        }
        return { tripDateDisplay: tripDateDisplay, initiatedByDisplay: initiatedByDisplay };
    };
    HelperService.extractPoolTripsFromBulkResponse = function (response) {
        if (Array.isArray(response)) {
            return response;
        }
        if (response && Array.isArray(response.data)) {
            return response.data;
        }
        if (response && response.data && Array.isArray(response.data.data)) {
            return response.data.data;
        }
        return [];
    };
    HelperService.getOverlapScoreFromPoolTrip = function (poolTrip) {
        var score = poolTrip && poolTrip.scoreBreakdown &&
            poolTrip.scoreBreakdown.overlapStrategy &&
            poolTrip.scoreBreakdown.overlapStrategy.score;
        return score || null;
    };
    HelperService.buildOverlapScoreMap = function (poolTrips) {
        var overlapScoreMap = {};
        if (!Array.isArray(poolTrips)) {
            return overlapScoreMap;
        }
        poolTrips.forEach(function (poolTrip) {
            var orderId = poolTrip && poolTrip.orderId && String(poolTrip.orderId);
            var score = HelperService.getOverlapScoreFromPoolTrip(poolTrip);
            if (orderId && score) {
                overlapScoreMap[orderId] = score;
            }
        });
        return overlapScoreMap;
    };
    HelperService.collectDroppedOrderIds = function (orders) {
        var orderIds = (orders || [])
            .filter(function (order) { return order && order.status === 'dropped' && order._id; })
            .map(function (order) { return String(order._id); });
        return Array.from(new Set(orderIds));
    };
    HelperService.fetchOverlapScoreMap = function (orders, getPoolTripsBulk) {
        return __awaiter(this, void 0, void 0, function () {
            var droppedOrderIds, response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        droppedOrderIds = HelperService.collectDroppedOrderIds(orders);
                        if (droppedOrderIds.length === 0) {
                            return [2 /*return*/, {}];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getPoolTripsBulk(droppedOrderIds)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, HelperService.buildOverlapScoreMap(HelperService.extractPoolTripsFromBulkResponse(response))];
                    case 3:
                        e_2 = _a.sent();
                        // Silent failure — table still renders without overlap data
                        return [2 /*return*/, {}];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // Formats overlapStrategy.score ratios as "guest : XX%\nhost : YY%".
    HelperService.formatOverlapDisplay = function (overlapScore) {
        if (!overlapScore) {
            return '-';
        }
        var toPercent = function (value) {
            if (value === null || value === undefined || isNaN(Number(value))) {
                return '-';
            }
            return Math.round(Number(value) * 100) + '%';
        };
        return 'guest : ' + toPercent(overlapScore.guest) + '\nhost : ' + toPercent(overlapScore.host);
    };
    HelperService.buildWalletBalanceCardData = function (walletBalance, walletBalanceLoading, walletBalanceError) {
        if (walletBalance === null && !walletBalanceLoading) {
            return null;
        }
        var balanceValue = 'N/A';
        var showInr = false;
        if (walletBalanceLoading) {
            balanceValue = 'Loading...';
        }
        else if (walletBalanceError || walletBalance === 'Unable to fetch') {
            balanceValue = 'Unable to fetch';
        }
        else if (walletBalance) {
            balanceValue = walletBalance;
            showInr = true;
        }
        return {
            header: 'Wallet Balance',
            value: balanceValue,
            inr: showInr
        };
    };
    HelperService.debounce = function (func, delay) {
        if (delay === void 0) { delay = 3000; }
        var debounceTimer;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () { return func.apply(context, args); }, delay);
        };
    };
    return HelperService;
}());
export { HelperService };
